import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import useSWR from 'swr';

import {
    getSetting,
    saveSetting,
} from '../../services/identity/SettingService';
import {
    accountGlobalId,
    isHostModeSelector,
    userGlobalId,
} from '../../store/selectors';

const settingUrl = `/api/identity/Setting`;

export const useGetSetting = (keys: string[], passUserId = false) => {
    const partitionGlobalId = useSelector(accountGlobalId);
    const accountId = useSelector(userGlobalId);
    const isHostMode = useSelector(isHostModeSelector);

    return useSWR(
        {
            url: settingUrl,
            key: keys,
            partitionGlobalId,
            userId: passUserId ? accountId : undefined,
            isHostMode,
        },
        getSetting,
    );
};

export const useSetting = (keys: string[], passUserId = false) => {
    const accountId = useSelector(userGlobalId);
    const partitionGlobalId = useSelector(accountGlobalId);
    const isHostMode = useSelector(isHostModeSelector);

    const {
        data, isLoading,
    } = useGetSetting(keys, passUserId);

    const updateSettings = useCallback(async (settings: Array<{ key: string; value: any }>) => {
        saveSetting(settingUrl, {
            settings,
            partitionGlobalId,
            userId: passUserId ? accountId : undefined,
        }, isHostMode);
    }, [ partitionGlobalId, passUserId, accountId, isHostMode ]);

    return {
        settings: data,
        settingsLoading: isLoading,
        updateSettings,
    };
};
